(function ($, window, document, undefined) {

    "use strict";

    var pluginName = "tscroller";

    function Plugin(element) {
        this.element = element;
        this.wrapper = $(this.element).find('.scroll-wrapper');
        this.rightIndicator = $(this.element).find('.scroll-right-indicator');
        this.leftIndicator = $(this.element).find('.scroll-left-indicator');

        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            var self = this;

            if (this.isOverflowed()) {
                this.rightIndicator.addClass('show');
            }

            this.wrapper.on('scroll', function () {
                self.toggleScrollingIndication();
            });

            $(this.element).on('click', '.scroll-button-next', this.scrollRight.bind(this));
            $(this.element).on('click', '.scroll-button-prev', this.scrollLeft.bind(this));

        },

        checkPosition: function () {
            var scrollLeft = this.wrapper.scrollLeft(),
                innerWidth = this.wrapper.innerWidth(),
                scrollWidth = this.wrapper[0].scrollWidth;

            if(Math.round(scrollLeft + innerWidth) >= scrollWidth) {
                return 'right';
            } else if(scrollLeft === 0) {
                return 'left';
            } else {
                return 'scrolling';
            }
        },

        toggleScrollingIndication: function () {
            var position = this.checkPosition();

            if (position === 'right') {
                this.rightIndicator.removeClass('show');
            } else if (position === 'left') {
                this.leftIndicator.removeClass('show');
            } else {
                this.rightIndicator.addClass('show');
                this.leftIndicator.addClass('show');
            }
        },

        isOverflowed: function () {
            var innerWidth = this.wrapper.innerWidth(),
                scrollWidth = this.wrapper[0].scrollWidth;

            return scrollWidth > innerWidth;
        },

        scrolling: function (direction) {
            var scrollWidth = this.wrapper[0].scrollWidth,
                scrollLeft = this.wrapper.scrollLeft(),
                newScrollLeft = null;

            if (direction === 'right') {
                newScrollLeft = Math.round(scrollLeft + 60);
            } else {
                newScrollLeft = Math.round(scrollLeft - 60);
            }

            if (newScrollLeft > scrollWidth) {
                newScrollLeft = scrollWidth;
            }

            if (newScrollLeft < 0) {
                newScrollLeft = 0;
            }


            this.wrapper.scrollLeft(newScrollLeft);
        },

        scrollRight: function () {
            this.scrolling('right');
        },

        scrollLeft: function () {
            this.scrolling('left');
        }
    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
